import { useTranslation } from 'react-i18next'

import { Button } from '@mercai/clever'

import { Header, Tabs, TabsItemProps } from '@/components'
import { useParamsState } from '@/helpers'

import { DrawerLogisticPartnerForm } from '../components'
import {
  TabLogisticCarriers,
  TabLogisticImporters,
  TabLogisticRoutes,
} from '../tabs'
import styles from './list.module.css'
export const LogisticListPage = () => {
  const { t } = useTranslation('screenLogistic')

  const [queryParams, setQueryParams] = useParamsState({
    uuid: '',
    show: '',
    form: '',
    tab: '',
    type: 'transport_company',
  })

  const onHandleTab = (tab: string) => {
    const type: Record<string, string> = {
      carriers: 'transport_company',
      importers: 'import_company',
      routes: '',
    }

    setQueryParams({ tab, type: type?.[tab] || '' })
  }

  const onHandleNewRegister = () => {
    setQueryParams({ ...queryParams, form: 'create', uuid: '' })
  }

  const tabs: TabsItemProps[] = [
    {
      title: t('tabCarriers'),
      isActive: queryParams.tab === 'carriers' || !queryParams.tab,
      onSelect: () => onHandleTab('carriers'),
    },
    {
      title: t('tabImporters'),
      isActive: queryParams.tab === 'importers',
      onSelect: () => onHandleTab('importers'),
    },
    {
      title: t('tabRoutes'),
      isActive: queryParams.tab === 'routes',
      onSelect: () => onHandleTab('routes'),
    },
  ]

  const tabsContent: Record<
    string,
    { content: JSX.Element; new: JSX.Element }
  > = {
    carriers: {
      content: <TabLogisticCarriers />,
      new: (
        <Button onClick={onHandleNewRegister}>
          {t('tabLogisticCarriersNewRegister')}
        </Button>
      ),
    },
    importers: {
      content: <TabLogisticImporters />,
      new: (
        <Button onClick={onHandleNewRegister}>
          {t('tabLogisticImportersNewRegister')}
        </Button>
      ),
    },
    routes: {
      content: <TabLogisticRoutes />,
      new: <></>,
    },
  }

  return (
    <div className={styles.container}>
      <section className={styles['header-section']}>
        <Header
          title={t('title')}
          description={t('description')}
          className={styles.header}
        />
        {tabsContent[queryParams?.tab || 'carriers'].new}
      </section>

      <div className={styles.content}>
        <Tabs items={tabs} />

        {tabsContent[queryParams?.tab || 'carriers'].content}
      </div>

      <DrawerLogisticPartnerForm
        isOpen={!!queryParams.form}
        onHandleOpen={() =>
          setQueryParams({ ...queryParams, form: '', uuid: '' })
        }
        isImporter={!!(queryParams.tab === 'importers')}
      />
    </div>
  )
}
